import { render } from "./carousel.vue?vue&type=template&id=1050040c&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=1050040c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1050040c"],['__file',"src/js/components/carousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1050040c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1050040c', __exports__)) {
    api.reload('1050040c', __exports__)
  }
  
  module.hot.accept("./carousel.vue?vue&type=template&id=1050040c&scoped=true", () => {
    api.rerender('1050040c', render)
  })

}


export default __exports__